/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Filters = ({
  selected,
  setSelected,
  searchTerm,
  setSearchTerm,
  country,
  setCountry,

  // ⭐ étoiles contrôlées par le parent
  starsSelected,
  setStarsSelected,
}) => {
  const categories = ['tous', 'tour', 'sejour'];

  const labels = {
    tous: 'Tous',
    tour: 'Circuit',
    sejour: 'Séjour',
  };

  const [counts, setCounts] = useState({ tous: 0, tour: 0, sejour: 0 });
  const [countries, setCountries] = useState([]);
  const [starsOptions, setStarsOptions] = useState([]); // [{stars, count}]

  const capFirst = (s = '') =>
    s[0]?.toLocaleUpperCase('fr-FR') + s.slice(1).toLocaleLowerCase('fr-FR');

  // 🌍 Pays
  useEffect(() => {
    axios
      .get(`/api/products/countries`)
      .then(({ data }) => setCountries(Array.isArray(data) ? data : []))
      .catch((err) => console.error('Erreur chargement pays', err));
  }, []);

  // 🔢 Compteurs (⚠️ on garde "tous" du backend, pas de recalcul)
  useEffect(() => {
    const ctrl = new AbortController();

    (async () => {
      try {
        const { data } = await axios.get(`/api/products/typesCount`, {
          params: { searchTerm, country },
          signal: ctrl.signal,
        });

        const d = { tous: 0, tour: 0, sejour: 0, ...(data || {}) };

        setCounts({
          tous: Number(d.tous) || 0,
          tour: Number(d.tour) || 0,
          sejour: Number(d.sejour) || 0,
        });
      } catch (e) {
        if (axios.isCancel?.(e) || e.name === 'CanceledError') return;
        console.error('Erreur counts', e?.response?.data || e);
        setCounts({ tous: 0, tour: 0, sejour: 0 });
      }
    })();

    return () => ctrl.abort();
  }, [searchTerm, country]);

  // ⭐ Options étoiles (dynamiques)
  useEffect(() => {
    const ctrl = new AbortController();

    (async () => {
      try {
        const { data } = await axios.get('/api/products/starsCount', {
          params: { searchTerm, country },
          signal: ctrl.signal,
        });
        setStarsOptions(Array.isArray(data) ? data : []);
      } catch (e) {
        if (axios.isCancel?.(e) || e.name === 'CanceledError') return;
        setStarsOptions([]);
      }
    })();

    return () => ctrl.abort();
  }, [searchTerm, country]);

  // ⭐ toggle étoile
  const toggleStar = (v) => {
    setStarsSelected((prev) =>
      prev.includes(v) ? prev.filter((x) => x !== v) : [...prev, v],
    );
  };

  return (
    <div className="row mb-4">
      <div className="col-12">
        <input
          type="text"
          className="form-control mb-3"
          placeholder="Destination, Séjour ou circuit"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="col-12 d-flex flex-wrap align-items-center gap-2 mb-2 justify-content-between">
        <div>
          {categories.map((cat) => (
            <button
              key={cat}
              className={`btn btn-${selected === cat ? 'primary' : 'outline-primary'} mx-1`}
              onClick={() => setSelected(cat)}
            >
              {labels[cat]} ({counts?.[cat] ?? 0})
            </button>
          ))}
        </div>

        <div className="ms-auto" style={{ minWidth: 320 }}>
          <select
            className="form-control"
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            style={{ height: '50px' }}
          >
            <option value="">Destination</option>
            {countries.map((c, idx) => (
              <option key={idx} value={c}>
                {capFirst(String(c))}
              </option>
            ))}
          </select>
        </div>

        {/* ⭐⭐ étoiles */}
        <div className="ms-auto stars-filter d-flex align-items-end">
          <div className="fw-semibold mb-2 mr-1">Catégorie : </div>

          {starsOptions.length === 0 ? (
            <div className="text-muted small">Aucune étoile disponible</div>
          ) : (
            <div className="stars-chips">
              {starsOptions.map((o) => {
                const active = starsSelected.includes(o.stars);
                return (
                  <button
                    key={o.stars}
                    type="button"
                    className={`stars-chip ${active ? 'is-active' : ''}`}
                    onClick={() => toggleStar(o.stars)}
                    aria-pressed={active}
                    title={`${o.stars} étoiles`}
                  >
                    <span className="stars-chip__value">{o.stars}★</span>
                    <span className="stars-chip__count">({o.count})</span>
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Filters;
